var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elementsTablePreview"},[_c('section',{staticClass:"ulPreview"},[_c('section',{staticClass:"wrapper"},[_c('section',{staticClass:"question-text texttable",class:{ wideTable: _vm.numberOfColumns > 3 }},[_c('p',[_c('span',{attrs:{"text-left":""},domProps:{"innerHTML":_vm._s(_vm.sanitizeHTML(_vm.translation))}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }